<template>
  <SimpleBar ref="scroller" class="virtual-list">
    <div class="list-view-phantom" :style="{ height: contentHeight }">
      <div ref="content" class="list-view-content">
        <slot v-if="visibleData" :visibleData="visibleData" />
      </div>
    </div>
  </SimpleBar>
</template>
<script>
import SimpleBar from 'com/SimpleBar'
export default {
  name: 'VirtualList',
  components: { SimpleBar },
  props: {
    list: {
      type: Array,
      require: true
    },
    itemHeight: {
      type: Number,
      require: true
    },
    isReset: Boolean
  },
  data: () => ({
    start: 0,
    end: 0,
    scheduledAnimationFrame: false
  }),
  computed: {
    show() {
      return this.list && this.list.length > 0
    },
    contentHeight() {
      if (this.show) {
        return this.list.length * this.itemHeight + 'px'
      }
    },
    visibleData() {
      return this.show ? this.list.slice(this.start, this.end) : []
    }
  },
  mounted() {
    this.$scroller = this.$refs.scroller.scrollElement
    this.$scroller.addEventListener('scroll', this.handleScrollEvent, false)
    window.addEventListener('resize', this.handleScrollEvent)
    this.handleScrollEvent()
  },
  beforeDestroy() {
    this.$scroller.removeEventListener('scroll', this.handleScrollEvent)
    window.removeEventListener('resize', this.handleScrollEvent)
  },
  methods: {
    handleScrollEvent() {
      if (this.scheduledAnimationFrame) {
        return
      }
      this.scheduledAnimationFrame = true
      // requestAnimationFrame 被调用的频率是每秒60次，可以限制滚动事件触发次数
      window.requestAnimationFrame(timestamp => {
        this.scheduledAnimationFrame = false
        const scrollTop = this.$scroller.scrollTop
        this.updateVisibleData(scrollTop || 0)
        this.$emit('scroll', scrollTop)
      })
    },
    updateVisibleData(scrollTop) {
      const content = this.$refs.content
      if (this.list && this.list.length > 0 && content) {
        const visibleCount = Math.ceil(this.$el.clientHeight / this.itemHeight)
        this.start =
          scrollTop / this.itemHeight <= 3
            ? 0
            : Math.floor(scrollTop / this.itemHeight) - 3
        this.end = Math.floor(scrollTop / this.itemHeight) + visibleCount + 3
        content.style.transform = `translate3d(0, ${this.start *
          this.itemHeight}px, 0)`
      }
    },
    scrollListTop(top) {
      this.$scroller.scrollTop = top
    },
    resetScroller(reset) {
      if (reset && this.$scroller) {
        this.scrollListTop(0)
        this.updateVisibleData(0)
        this.$emit('resetData', false)
      }
    }
  },
  watch: {
    isReset(reset) {
      this.resetScroller()
    }
  }
}
</script>
<style lang="less" scoped>
.virtual-list {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .list-view-content {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}
</style>
